export default "__VITE_ASSET__BJ7cLxJ2__"